<!-- @format -->
<ng-template #drawerContent>
	<div class="hmf-m-s hmf-my-md-xs hmf-mx-md-m">
		<p class="hmf-header-bold-s hmf-my-xs">Protect Your Purchase</p>
	</div>
	<div class="scroll-content hmf-h-100">
		<div class="hmf-m-s hmf-mx-md-m hmf-mb-md-m hmf-mt-md-0">
			<!-- AEM component + horizontal line will go here -->
			<pdp-component-warranty-plan-selector
				[isLoading]="true"
				[warranties]="[]"
				[(selectedPlanSku)]="selectedPlanSku">
			</pdp-component-warranty-plan-selector>
		</div>
	</div>
	<div class="top-shadow hmf-px-m hmf-py-s hmf-mt-auto hmf-w-100">
		<div>
			<button
				class="hmf-w-100"
				hmf-button
				variant="primary"
				[disabled]="true">
				save selection
			</button>
		</div>
	</div>
</ng-template>
